// Placeholder data used to render service template thumbnails inside the guided builder.
// Mirrors the objects used by the classic builder's Step 3 gallery.
import heroPropertyImage from "@/assets/hero-property.jpg";
import heroproperties from "@/assets/hero-properties.jpg";
import landscaping from "@/assets/property-image.jpg";

export const serviceDummyData = {
  // Data object that most service templates expect
  data: {
    headline: "Professional Real Estate Services",
    subheadline: "Your Trusted Partner in Real Estate",
    description: "We provide comprehensive real estate services including property management, buying, selling, and investment consulting. Our team of experts is dedicated to helping you achieve your real estate goals.",
    serviceName: "Premium Property Management",
    serviceTitle: "Expert Real Estate Solutions",
    companyName: "Premier Real Estate Group",
    tagline: "Excellence in Every Transaction",

    // Agent/Contact info
    agentName: "John Smith",
    agentTitle: "Senior Real Estate Agent",
    agentPhone: "(555) 123-4567",
    agentEmail: "john.smith@realestate.com",
    phone: "(555) 123-4567",
    email: "john.smith@realestate.com",
    website: "www.premierrealestate.com",
    address: "123 Main Street, Beverly Hills, CA 90210",

    // ALL POSSIBLE IMAGE PROP NAMES
    heroImage: heroPropertyImage,
    image: heroPropertyImage,
    mainImage: heroPropertyImage,
    backgroundImage: heroPropertyImage,
    agentImage: heroPropertyImage,
    agentPhoto: heroPropertyImage,
    logo: heroPropertyImage,
    companyLogo: heroPropertyImage,
    profileImage: heroPropertyImage,
    coverImage: heroPropertyImage,
    bannerImage: heroPropertyImage,
    primaryImage: heroPropertyImage,
    secondaryImage: heroproperties,
    photo: heroPropertyImage,
    photos: [heroPropertyImage, heroproperties, landscaping],
    images: [heroPropertyImage, heroproperties, landscaping],
    gallery: [heroPropertyImage, heroproperties, landscaping],

    // Service type
    serviceType: "Real Estate Services",
    service_type: "Real Estate Services",

    // Services list
    services: [
      "Property Valuation",
      "Market Analysis",
      "Home Staging",
      "Professional Photography",
      "Virtual Tours",
      "Negotiation Support"
    ],

    // Features - both array of strings and array of objects
    features: [
      { id: 1, feature_name: "24/7 Support" },
      { id: 2, feature_name: "Free Consultation" },
      { id: 3, feature_name: "Expert Team" },
      { id: 4, feature_name: "Fast Response" },
      { id: 5, feature_name: "Proven Results" }
    ],
    featuresList: [
      "24/7 Support",
      "Free Consultation",
      "Expert Team",
      "Fast Response",
      "Proven Results"
    ],

    // Stats
    stats: {
      propertiesSold: "500+",
      yearsExperience: "15+",
      happyClients: "1000+",
      awards: "25+"
    },

    // Testimonial
    testimonial: "Best real estate service I've ever used! Highly recommended.",
    testimonialAuthor: "Sarah Johnson",
    testimonialRole: "Happy Homeowner",

    // CTA
    ctaText: "Contact Us Today",
    ctaButton: "Get Started",
  },

  // ============ DIRECT PROPS (for templates that don't use data wrapper) ============

  // ALL POSSIBLE IMAGE PROP NAMES AS DIRECT PROPS
  heroImage: heroPropertyImage,
  image: heroPropertyImage,
  mainImage: heroPropertyImage,
  backgroundImage: heroPropertyImage,
  agentImage: heroPropertyImage,
  agentPhoto: heroPropertyImage,
  logo: heroPropertyImage,
  companyLogo: heroPropertyImage,
  profileImage: heroPropertyImage,
  coverImage: heroPropertyImage,
  bannerImage: heroPropertyImage,
  primaryImage: heroPropertyImage,
  secondaryImage: heroproperties,
  photo: heroPropertyImage,
  photos: [heroPropertyImage, heroproperties, landscaping],
  images: [heroPropertyImage, heroproperties, landscaping],
  gallery: [heroPropertyImage, heroproperties, landscaping],

  // Text content
  headline: "Professional Real Estate Services",
  subheadline: "Your Trusted Partner in Real Estate",
  description: "We provide comprehensive real estate services including property management, buying, selling, and investment consulting.",
  serviceName: "Premium Property Management",
  serviceType: "Real Estate Services",
  service_type: "Real Estate Services",
  title: "Professional Real Estate Services",

  // Contact info as direct props
  agentName: "John Smith",
  name: "John Smith",
  agentPhone: "(555) 123-4567",
  agentEmail: "john.smith@realestate.com",
  phone: "(555) 123-4567",
  email: "john.smith@realestate.com",
  companyName: "Premier Real Estate Group",
  company: "Premier Real Estate Group",
  website: "www.premierrealestate.com",
  address: "123 Main Street, Beverly Hills, CA 90210",

  // Services and features as direct props
  services: [
    "Property Valuation",
    "Market Analysis",
    "Home Staging",
    "Professional Photography"
  ],
  features: [
    { id: 1, feature_name: "24/7 Support" },
    { id: 2, feature_name: "Free Consultation" },
    { id: 3, feature_name: "Expert Team" },
    { id: 4, feature_name: "Fast Response" }
  ],
  featuresList: [
    "24/7 Support",
    "Free Consultation",
    "Expert Team",
    "Fast Response"
  ],

  // Control props
  readOnly: true,
  isPreview: true,
  editable: false,
  preview: true,
  onChange: () => { },
  onSave: () => { },
  onUpdate: () => { },
};

// Create a service-like object for templates that expect a 'service' prop
export const dummyService = {
  id: 1,
  title: "Professional Real Estate Services",
  headline: "Professional Real Estate Services",
  description: "We provide comprehensive real estate services including property management, buying, selling, and investment consulting.",
  serviceType: "Real Estate Services",
  service_type: "Real Estate Services",
  // Images
  heroImage: heroPropertyImage,
  image: heroPropertyImage,
  mainImage: heroPropertyImage,
  secondaryImage: heroproperties,
  photo: heroPropertyImage,
  photos: [heroPropertyImage, heroproperties, landscaping],
  images: [heroPropertyImage, heroproperties, landscaping],
  // Contact
  phone: "(555) 123-4567",
  email: "john.smith@realestate.com",
  address: "123 Main Street, Beverly Hills, CA 90210",
  website: "www.premierrealestate.com",
  agentName: "John Smith",
  name: "John Smith",
  companyName: "Premier Real Estate Group",
  // Features
  features: [
    { id: 1, feature_name: "24/7 Support" },
    { id: 2, feature_name: "Free Consultation" },
    { id: 3, feature_name: "Expert Team" },
    { id: 4, feature_name: "Fast Response" }
  ],
};
